import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import React from 'react'

const DiscriptionModal = ({  onToggleModal, data, }) => {
    const stripHtml = (html) => html.replace(/<[^>]*>?/gm, ""); 


  return (
     <Dialog
        onClose={(event, reason) => { if (reason !== 'backdropClick') {  onToggleModal();}}}
        disableEscapeKeyDown
        aria-labelledby="customized-dialog-title"
        className="add-lease-dialog"
        maxWidth="md"
        fullWidth
        open={true}
        >
        <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
         <Typography sx={{ marginLeft: "15px" }}> {data?.notification_type?.label} </Typography>
        </DialogTitle>
        <DialogContent dividers>
        <TextField
          multiline
          variant="filled"
          fullWidth
          disabled={true}
          value={stripHtml(data?.description)}
          sx={{ '& .MuiFilledInput-root': { padding: '8px' }, '& .MuiFilledInput-input': { color: '#000000', WebkitTextFillColor: '#000000' } }}
          />

        </DialogContent>
        <DialogActions sx={{marginRight: "15px"}}>
          <Button className='cancel-btn' variant="outlined" size="small" onClick={onToggleModal}> Close</Button>
        </DialogActions>
        </Dialog>
  )
}

export default DiscriptionModal